import React, { useState } from "react";
import { ReactSVG } from "react-svg";
import toast from "react-hot-toast";
import I18n from "i18n-js";

import { MIME_TYPES } from "../../config/mime_types";

import { getReadableFileSize } from "../../services/file";

import api from "../../api";

import IconButton from "../../commons/IconButton";

import documentIcon from "icons/document.svg";
import downloadIcon from "icons/download.svg";
import deleteIcon from "icons/delete-outline.svg";

const ResumeDetails = ({ resume, onResumeDeleted }) => {

  const [loading, setLoading] = useState(false);

  const getFileAndCreateDownload = () => {
    api.get(resume?.link, { responseType: "blob" })
      .then(res => {
        console.log(res);
        createDownload(res.data);
      })
      .catch(err => {
        if (err.response && err.response.data && err.response.data.message) {
          toast.error(<b>{err.response.data.message}</b>);
        } else {
          toast.error(<b>{I18n.t("common.errors.unexpected_error")}</b>);
        }
        console.error(err);
      });
  }

  const createDownload = (data) => {
    const href = URL.createObjectURL(data);

    const link = document.createElement("a");
    link.href = href;
    link.setAttribute("download", resume?.filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(href);
  }

  const deleteResume = () => {
    setLoading(true);

    api.delete("/users/resume")
    .then(_ => {
      toast.success(<b>{I18n.t("common.deleted_successfully")}</b>);
      onResumeDeleted && onResumeDeleted();
    })
    .catch(err => {
      if (err.response && err.response.data && err.response.data.message) {
        toast.error(<b>{err.response.data.message}</b>);
      } else {
        toast.error(<b>{I18n.t("common.errors.unexpected_error")}</b>);
      }
      setLoading(false);
      console.error(err);
    });
  }

  return (
    <div className="resume-details">
      <ReactSVG className="document" src={documentIcon} />
      <div className="info">
        <span className="name">{resume?.filename}</span>
        <span>
          {MIME_TYPES[resume.format]}
          <span className="dot-sep"> · </span>
          {getReadableFileSize(resume?.byte_size)}
        </span>
      </div>
      <div className="actions">
        <IconButton
          title={I18n.t("common.actions.download")}
          icon={downloadIcon}
          tooltipPlacement="top"
          onClick={() => getFileAndCreateDownload()}
        />
        <IconButton
          title={I18n.t("common.actions.delete")}
          icon={deleteIcon}
          loading={loading}
          tooltipPlacement="top"
          onClick={() => deleteResume()}
        />
      </div>
    </div>
  );
}

export default ResumeDetails;
